import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from '../../components/LoaderScreen';
import { GetMonthName } from '../../helpers/GetMonthName';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useBox } from '../../Finanzas/Helper/useBox';
import FiltroReporteRefacciones from './FiltroReporteRefacciones';
import { ChartFamiliasRefacciones, ANIOS as ANIOS_COMPARATIVA } from './ChartFamiliasRefacciones';
import { FiltroMultiSelect } from './FiltroMultiSelect';
import { KpiCard } from './KpiCard';
import { TablaParetoPorAnio } from './TablaParetoPorAnio';
import { TablaFamiliasPorGrupoPareto } from './TablaFamiliasPorGrupoPareto';
import { FormatMoney } from '../../../Helpers/FormatNumber';
import request from '../../../Helpers/API';
import { validarRangoFechas } from '../../../Helpers/ValidacionFechas';
import { CANTIDAD_MOSTRAR_OPCIONES } from '../../../Arrays/CantidadMostrarArray';
import {
    obtenerOpcionesFamiliaDesdeDetalle,
    obtenerOpcionesAsesorDesdeDetalle,
    obtenerOpcionesClienteDesdeDetalle,
    obtenerOpcionesSubFamiliaDesdeDetalle,
    obtenerOpcionesSubFamilia2DesdeDetalle,
    obtenerOpcionesLineaDesdeDetalle,
} from '../../../Helpers/ReporteRefaccionesAgregaciones';
// El pipeline pesado (agrupaciones + Pareto + KPIs) se movió a un Web
// Worker (`reporteRefaccionesCalculosWorker.js`) para no bloquear el hilo
// principal cuando `detalle` crece — ver `useReporteRefaccionesCalculos.js`
// y el README para el detalle completo.
import { useReporteRefaccionesCalculos } from './useReporteRefaccionesCalculos';


//FILTROS
const sidebarFiltrosVacios = () => ({
    asesor: [],
    cliente: [],
    familia: [],
    subFamilia: [],
    subFamilia2: [],
    linea: [],
});

// Cantidades disponibles en el selector de la card de ranking
const OPCIONES_CANTIDAD_RANKING = CANTIDAD_MOSTRAR_OPCIONES;

const datosDashboardVacio = () => ({ detalle: [] });

const ReporteRefaccionesBoceto = () => {
    const history = useHistory();
    const { state: locationState } = useLocation();

    const [titulo, setTitulo] = useState("REPORTE REFACCIONES");


    //Filtros encargados de cargar algo en caso de volver de una pantala adelante
    const filtrosHeredados = locationState?.filtrosReporteRefacciones || null;

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    //Filtro inicial
    const initialStateboxfiltros = () => {
        if (filtrosHeredados?.boxstate) return filtrosHeredados.boxstate;
        return {
            fechaInicio: new Date(currentYear, currentMonth - 1, 1)
                .toISOString()
                .split("T")[0],
            fechaFin: today.toISOString().split("T")[0],
            anio: [],
            sucursal: [],
            adr: [],
        };
    };

    const [boxstate, setBoxState] = useBox(initialStateboxfiltros());

    // Filtros del sidebar: acotan en memoria lo ya traído (no llaman de nuevo al endpoint).
    const [sidebarFiltros, setSidebarFiltros] = useState(
        filtrosHeredados?.sidebarFiltros || sidebarFiltrosVacios()
    );


    const [tabRanking, setTabRanking] = useState(filtrosHeredados?.tabRanking || "familia");
    const [cantidadRanking, setCantidadRanking] = useState(filtrosHeredados?.cantidadRanking || "10");
    const [ordenRanking, setOrdenRanking] = useState(filtrosHeredados?.ordenRanking || "desc");

    //datos que retorna el endpoint
    const [datosDashboard, setDatosDashboard] = useState(datosDashboardVacio());

    //Boxstate de los filtros
    const [ultimoBoxstateCargado, setUltimoBoxstateCargado] = useState(initialStateboxfiltros);

    const onCambiarFiltroSidebar = (key, nuevaSeleccion) => {
        setSidebarFiltros((prev) => ({ ...prev, [key]: nuevaSeleccion }));
    };

    const onLimpiarFiltrosSidebar = () => setSidebarFiltros(sidebarFiltrosVacios());

    //Control de filtros desplegables ára saber cual esta abierto
    const [filtroSidebarAbierto, setFiltroSidebarAbierto] = useState(null);

    const onToggleFiltroSidebar = (key) => {
        setFiltroSidebarAbierto((prev) => (prev === key ? null : key));
    };


    const construirIdsOTodos = (seleccion) =>
        seleccion && seleccion.length > 0 ? seleccion.join(",") : "0";


    const construirAniosComparativa = (state) => {
        const seleccionados =
            state.anio && state.anio.length > 0
                ? state.anio.map(String)
                : ANIOS_COMPARATIVA.map(String);
        const anioFin = state.fechaFin ? state.fechaFin.split("-")[0] : null;
        const conPrincipal =
            anioFin && !seleccionados.includes(anioFin)
                ? [...seleccionados, anioFin]
                : seleccionados;
        return conPrincipal.sort((a, b) => Number(a) - Number(b));
    };

    // Título del header según el rango cargado: "Julio 2026", "Enero - Julio
    // 2026" o "Enero 2025 - Julio 2026".
    const construirTituloReporte = (state) => {
        if (!state.fechaInicio || !state.fechaFin) return "REPORTE REFACCIONES";

        const [anioInicio, mesInicio] = state.fechaInicio.split("-");
        const [anioFin, mesFin] = state.fechaFin.split("-");

        if (anioInicio === anioFin && mesInicio === mesFin) {
            return `REPORTE REFACCIONES - ${GetMonthName(Number(mesInicio))} ${anioInicio}`;
        }

        const etiquetaInicio = `${GetMonthName(Number(mesInicio))}${anioInicio !== anioFin ? " " + anioInicio : ""
            }`;
        const etiquetaFin = `${GetMonthName(Number(mesFin))} ${anioFin}`;
        return `REPORTE REFACCIONES - ${etiquetaInicio} - ${etiquetaFin}`;
    };

    //Construccion de los parametros para el endpoint
    const construirQueryDashboard = (state) => {
        const params = new URLSearchParams();
        params.set("fechainicio", state.fechaInicio);
        params.set("fechafin", state.fechaFin);
        params.set("comparativa", construirAniosComparativa(state).join(","));
        params.set("adr", construirIdsOTodos(state.adr));
        params.set("sucursal", construirIdsOTodos(state.sucursal));
        return params.toString();
    };

    //ENDPOINT
    const onExecute = (state, { limpiarSidebar = true } = {}) => {
        return new Promise((resolve, reject) => {
            const validacion = validarRangoFechas(state.fechaInicio, state.fechaFin);
            if (!validacion.ok) {
                Swal.fire("REPORTE REFACCIONES", validacion.mensaje, "warning");
                reject(new Error(validacion.mensaje));
                return;
            }

            setLoader((prev) => ({ ...prev, mostrar: true }));

            const query = construirQueryDashboard(state);
            request
                .get(`DashboardRefacciones/Dashboard?${query}`)
                .then((result) => {
                    setDatosDashboard({
                        detalle: result?.detalle || [],
                    });
                    setTitulo(construirTituloReporte(state));

                    //Guardado de los filtros usados
                    setUltimoBoxstateCargado(state);
                    //Limpieza de filtros en sidebar
                    if (limpiarSidebar) {
                        setSidebarFiltros(sidebarFiltrosVacios());
                    }
                    setLoader((prev) => ({ ...prev, mostrar: false }));
                    resolve(result);
                })
                .catch((error) => {
                    console.error(error);
                    setLoader((prev) => ({ ...prev, mostrar: false }));
                    Swal.fire(
                        "REPORTE REFACCIONES",
                        "No fue posible cargar la información del reporte. Intente nuevamente o contacte al administrador.",
                        "error"
                    );
                    reject(error);
                });
        });
    };


    // Al volver de Pantalla 2/3/Vendedor (Regresar), `filtrosHeredados` trae
    // `detalleCompleto`/`titulo` (guardados por onFamiliaClick/onClienteClick/
    // onVendedorClick antes de navegar): se restauran directo y NO se llama
    // al endpoint de nuevo. Solo se llama al endpoint aquí cuando se entra
    // "en frío" (sin ese detalle heredado, ej. desde el menú/Dashboard). El
    // botón "Cargar" del filtro sigue llamando a `onExecute` directamente
    // (ver `onExecute={onExecute}` en el JSX), sin pasar por este efecto.
    useEffect(() => {
        if (filtrosHeredados?.detalleCompleto) {
            setDatosDashboard({ detalle: filtrosHeredados.detalleCompleto });
            if (filtrosHeredados.titulo) setTitulo(filtrosHeredados.titulo);
            return;
        }
        onExecute(boxstate, { limpiarSidebar: false }).catch(() => { });
    }, []);

    // Año principal: ordena/limita el ranking y acota los KPIs a un solo año.
    const anioPrincipal = useMemo(
        () =>
            ultimoBoxstateCargado.fechaFin
                ? ultimoBoxstateCargado.fechaFin.split("-")[0]
                : String(currentYear),
        [ultimoBoxstateCargado]
    );

    const aniosComparativos = useMemo(
        () => construirAniosComparativa(ultimoBoxstateCargado),
        [ultimoBoxstateCargado]
    );

    // Grupo activo de "Familias del grupo 80%/20%"; empieza en "80".
    const [grupoParetoSeleccionado, setGrupoParetoSeleccionado] = useState("80");
    const [metricaFamiliasPareto, setMetricaFamiliasPareto] = useState("monto");
    const [cantidadFamiliasPareto, setCantidadFamiliasPareto] = useState("10");
    const [ordenFamiliasPareto, setOrdenFamiliasPareto] = useState("desc");

    // Pipeline pesado (filtro de sidebar + agrupaciones por Familia/Cliente/
    // Vendedor + Pareto de Clientes por año + Familias del grupo Pareto +
    // KPIs) en un Web Worker — ver useReporteRefaccionesCalculos.js. Un
    // cambio en cualquiera de estos 6 valores dispara un recálculo.
    const {
        detalleFiltrado,
        datosGraficaFamilias,
        datosGraficaClientes,
        datosGraficaVendedores,
        paretoClientesPorAnio,
        familiasDelGrupoPareto,
        kpisCalculados,
        calculando,
    } = useReporteRefaccionesCalculos({
        detalle: datosDashboard.detalle,
        sidebarFiltros,
        grupoParetoSeleccionado,
        metricaFamiliasPareto,
        aniosComparativos,
        anioPrincipal,
    });

    // El loader grande solo se muestra si el cálculo tarda más de 200ms —
    // evita el parpadeo del overlay completo en cada clic de filtro cuando
    // el recálculo es casi instantáneo (dataset chico/mediano). Con datasets
    // grandes, donde sí tarda, el usuario ve el loader como corresponde.
    const [mostrarLoaderCalculo, setMostrarLoaderCalculo] = useState(false);
    useEffect(() => {
        if (!calculando) {
            setMostrarLoaderCalculo(false);
            return;
        }
        const temporizador = setTimeout(() => setMostrarLoaderCalculo(true), 200);
        return () => clearTimeout(temporizador);
    }, [calculando]);

    const kpis = useMemo(
        () => ({
            totalGeneral: `$${FormatMoney(kpisCalculados.totalGeneral, 0)}`,
            clientesTotales: kpisCalculados.clientesTotales.toLocaleString("es-MX"),
            familiasTotales: kpisCalculados.familiasTotales.toLocaleString("es-MX"),
        }),
        [kpisCalculados]
    );

    //Filtros de sidebar
    const opcionesAsesor = useMemo(
        () => obtenerOpcionesAsesorDesdeDetalle(datosDashboard.detalle),
        [datosDashboard.detalle]
    );

    const opcionesCliente = useMemo(
        () => obtenerOpcionesClienteDesdeDetalle(datosDashboard.detalle),
        [datosDashboard.detalle]
    );

    const opcionesFamilia = useMemo(
        () => obtenerOpcionesFamiliaDesdeDetalle(datosDashboard.detalle),
        [datosDashboard.detalle]
    );

    const opcionesSubFamilia = useMemo(
        () => obtenerOpcionesSubFamiliaDesdeDetalle(datosDashboard.detalle),
        [datosDashboard.detalle]
    );

    const opcionesSubFamilia2 = useMemo(
        () => obtenerOpcionesSubFamilia2DesdeDetalle(datosDashboard.detalle),
        [datosDashboard.detalle]
    );


    const opcionesLinea = useMemo(
        () => obtenerOpcionesLineaDesdeDetalle(datosDashboard.detalle),
        [datosDashboard.detalle]
    );

    const CAMPOS_FILTRO_SIDEBAR = [
        { key: "asesor", label: "Asesor", opciones: opcionesAsesor },
        { key: "cliente", label: "Cliente", opciones: opcionesCliente },
        { key: "familia", label: "Familia", opciones: opcionesFamilia },
        { key: "subFamilia", label: "Sub Familia", opciones: opcionesSubFamilia },
        { key: "subFamilia2", label: "Sub Familia 2", opciones: opcionesSubFamilia2 },
        { key: "linea", label: "Línea", opciones: opcionesLinea },
    ];


    const datosRankingActivo =
        tabRanking === "cliente"
            ? datosGraficaClientes
            : tabRanking === "vendedor"
                ? datosGraficaVendedores
                : datosGraficaFamilias;

    // Resuelve la etiqueta visible de cada valor seleccionado (ej. idcliente → razón social).
    const construirChipDinamico = (key, label, seleccion, opciones) => {
        const activo = seleccion.length > 0;
        const etiquetas = opciones
            .filter((o) => seleccion.includes(o.value))
            .map((o) => o.label);
        return {
            key,
            label,
            activo,
            valor: !activo ? "Todos" : etiquetas.join(", "),
        };
    };

    // Un chip por filtro del sidebar.
    const chipsAplicados = CAMPOS_FILTRO_SIDEBAR.map((campo) =>
        construirChipDinamico(campo.key, campo.label, sidebarFiltros[campo.key], campo.opciones)
    );

    // Navega a Pantalla 2 con el detalle ya cargado (sin re-llamar al endpoint).
    // `filtrosReporteRefacciones` lleva `detalleCompleto`/`titulo` (el `detalle`
    // SIN filtrar por sidebar, tal cual lo devolvió el endpoint, + el título
    // ya armado) para que, al presionar "Regresar" desde Pantalla 2/3, esta
    // pantalla los restaure directo (`useEffect` de abajo) sin volver a
    // llamar al endpoint. Ver README para el detalle completo.
    const onFamiliaClick = useCallback(
        ({ id, etiqueta }) => {
            history.push({
                pathname: "/PostVenta/ReporteRefaccionesDetalleFamilia",
                state: {
                    boxstate: ultimoBoxstateCargado,
                    familia: { id, nombre: etiqueta },
                    detalle: detalleFiltrado,
                    filtrosReporteRefacciones: {
                        boxstate: ultimoBoxstateCargado,
                        sidebarFiltros,
                        tabRanking,
                        cantidadRanking,
                        ordenRanking,
                        detalleCompleto: datosDashboard.detalle,
                        titulo,
                    },
                },
            });
        },
        [
            history,
            ultimoBoxstateCargado,
            sidebarFiltros,
            tabRanking,
            cantidadRanking,
            ordenRanking,
            detalleFiltrado,
            datosDashboard.detalle,
            titulo,
        ]
    );

    // Igual que onFamiliaClick; sin `familia` (Pantalla 3 usa "Todas" si no viene de Pantalla 2).
    const onClienteClick = useCallback(
        ({ id, etiqueta }) => {
            history.push({
                pathname: "/PostVenta/ReporteRefaccionesDetalleCliente",
                state: {
                    boxstatePadre: ultimoBoxstateCargado,
                    cliente: { id, nombre: etiqueta },
                    detalle: detalleFiltrado,
                    filtrosReporteRefacciones: {
                        boxstate: ultimoBoxstateCargado,
                        sidebarFiltros,
                        tabRanking,
                        cantidadRanking,
                        ordenRanking,
                        detalleCompleto: datosDashboard.detalle,
                        titulo,
                    },
                },
            });
        },
        [
            history,
            ultimoBoxstateCargado,
            sidebarFiltros,
            tabRanking,
            cantidadRanking,
            ordenRanking,
            detalleFiltrado,
            datosDashboard.detalle,
            titulo,
        ]
    );

    // Igual que onFamiliaClick/onClienteClick, a "Detalle por Vendedor" (2026-07-29).
    const onVendedorClick = useCallback(
        ({ id, etiqueta }) => {
            history.push({
                pathname: "/PostVenta/ReporteRefaccionesDetalleVendedor",
                state: {
                    boxstate: ultimoBoxstateCargado,
                    vendedor: { id, nombre: etiqueta },
                    detalle: detalleFiltrado,
                    filtrosReporteRefacciones: {
                        boxstate: ultimoBoxstateCargado,
                        sidebarFiltros,
                        tabRanking,
                        cantidadRanking,
                        ordenRanking,
                        detalleCompleto: datosDashboard.detalle,
                        titulo,
                    },
                },
            });
        },
        [
            history,
            ultimoBoxstateCargado,
            sidebarFiltros,
            tabRanking,
            cantidadRanking,
            ordenRanking,
            detalleFiltrado,
            datosDashboard.detalle,
            titulo,
        ]
    );

    const onRankingClick =
        tabRanking === "cliente" ? onClienteClick : tabRanking === "vendedor" ? onVendedorClick : onFamiliaClick;

    return (
        <PlantillaScreen
            titulo={titulo}
            className={"plantilla-reporte-refacciones"}
            className_main={1}
        >
            {/* `loader` = llamada al endpoint (onExecute); `mostrarLoaderCalculo` =
                pipeline pesado corriendo en el Web Worker (más de 200ms). */}
            <LoaderScreen loader={{ ...loader, mostrar: loader.mostrar || mostrarLoaderCalculo }} />
            <div className="peb-actions">
                <div
                    className="peb-actions-regresar"

                    onClick={() => {
                        history.push("/PostVenta/Dashboard")
                    }}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="peb-actions-filtro">
                    {/* Pre-marca los checkboxes de Región/Sucursal al volver de Pantalla 2/3. */}
                    <FiltroReporteRefacciones
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        sucursalesEncontrados={
                            boxstate.sucursal && boxstate.sucursal.length > 0
                                ? boxstate.sucursal.join(",")
                                : ""
                        }
                        adrEncontrados={
                            boxstate.adr && boxstate.adr.length > 0 ? boxstate.adr.join(",") : ""
                        }
                    />
                </div>

            </div>

            <div className="peb-main-layout">
                <div className="peb-sidebar-filtros scroll">
                    <div className="peb-sidebar-seccion">
                        <div className="peb-sidebar-seccion-titulo">Filtros</div>
                        {CAMPOS_FILTRO_SIDEBAR.map((campo) => (
                            <FiltroMultiSelect
                                key={campo.key}
                                label={campo.label}
                                options={campo.opciones}
                                selected={sidebarFiltros[campo.key]}
                                onChange={(nuevaSeleccion) =>
                                    onCambiarFiltroSidebar(campo.key, nuevaSeleccion)
                                }
                                open={filtroSidebarAbierto === campo.key}
                                onToggle={() => onToggleFiltroSidebar(campo.key)}
                            />
                        ))}
                        <div
                            className="peb-sidebar-limpiar-todo"
                            onClick={onLimpiarFiltrosSidebar}
                        >
                            Limpiar todos los filtros
                        </div>
                    </div>

                    <div className="peb-sidebar-seccion">
                        <div className="peb-sidebar-seccion-titulo">Aplicados</div>
                        <div className="peb-sidebar-chips">
                            {chipsAplicados.map((chip) => (
                                <span
                                    key={chip.key}
                                    className={`peb-chip${chip.activo ? " peb-chip--activo" : ""}`}
                                >
                                    {chip.label}: {chip.valor}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="peb-main-content scroll">
                    <div className="peb-kpis">
                        <KpiCard titulo="Total General" valor={kpis.totalGeneral} />
                        <KpiCard titulo="Clientes Totales" valor={kpis.clientesTotales} />
                        <KpiCard titulo="Familias Totales" valor={kpis.familiasTotales} />
                    </div>

                    <div className="peb-report-container">
                        <div className="peb-report-header">
                            <div className="peb-report-tabs">
                                <div
                                    className={`peb-report-tab${tabRanking === "familia" ? " peb-report-tab--activo" : ""}`}
                                    onClick={() => setTabRanking("familia")}
                                >
                                    Ventas por Familia
                                </div>
                                <div
                                    className={`peb-report-tab${tabRanking === "cliente" ? " peb-report-tab--activo" : ""}`}
                                    onClick={() => setTabRanking("cliente")}
                                >
                                    Ventas por Cliente
                                </div>
                                <div
                                    className={`peb-report-tab${tabRanking === "vendedor" ? " peb-report-tab--activo" : ""}`}
                                    onClick={() => setTabRanking("vendedor")}
                                >
                                    Ventas por Vendedor
                                </div>
                            </div>
                            <div className="peb-report-controles">
                                <select
                                    className="peb-report-cantidad"
                                    value={cantidadRanking}
                                    onChange={({ target }) => setCantidadRanking(target.value)}
                                >
                                    {OPCIONES_CANTIDAD_RANKING.map((opcion) => (
                                        <option key={opcion} value={opcion}>
                                            {opcion === "todos" ? "Todos" : opcion}
                                        </option>
                                    ))}
                                </select>
                                <div
                                    className="peb-report-orden"
                                    title={
                                        ordenRanking === "desc"
                                            ? "Mostrando de mayor a menor. Clic para invertir."
                                            : "Mostrando de menor a mayor. Clic para invertir."
                                    }
                                    onClick={() =>
                                        setOrdenRanking((prev) => (prev === "desc" ? "asc" : "desc"))
                                    }
                                >
                                    {ordenRanking === "desc" ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
                                </div>
                            </div>
                        </div>
                        <div className="peb-report-chart">
                            <ChartFamiliasRefacciones
                                datos={datosRankingActivo}
                                anios={aniosComparativos}
                                anioPrincipal={anioPrincipal}
                                orden={ordenRanking}
                                cantidad={cantidadRanking}
                                onItemClick={onRankingClick}
                            />
                        </div>
                    </div>

                    <div className="peb-listados">
                        <TablaParetoPorAnio
                            datos={paretoClientesPorAnio}
                            grupoSeleccionado={grupoParetoSeleccionado}
                            onGrupoClick={setGrupoParetoSeleccionado}
                        />
                        <TablaFamiliasPorGrupoPareto
                            datos={familiasDelGrupoPareto}
                            anios={aniosComparativos}
                            anioPrincipal={anioPrincipal}
                            grupo={grupoParetoSeleccionado}
                            metrica={metricaFamiliasPareto}
                            onMetricaChange={setMetricaFamiliasPareto}
                            cantidad={cantidadFamiliasPareto}
                            onCantidadChange={setCantidadFamiliasPareto}
                            orden={ordenFamiliasPareto}
                            onOrdenChange={setOrdenFamiliasPareto}
                        />
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    )
}

export default ReporteRefaccionesBoceto
